import { useMutation } from '@tanstack/react-query';

import type { ApiError } from '@/_shared';
import { apiClient } from '@/_shared';

import type {
  AddressMutationSchema,
  AddressQuerySchema,
  AddressValidationRequest,
  AddressValidationResponse,
} from './shared';

export const useCreateAddressMutation = () =>
  useMutation<{ data: AddressQuerySchema }, ApiError, AddressMutationSchema>({
    mutationFn: async (payload) =>
      apiClient.request({
        method: 'POST',
        endpoint: '/api/v1/addresses',
        payload,
      }),
  });

export const useUpdateAddressMutation = () =>
  useMutation<{ data: AddressQuerySchema }, ApiError, AddressMutationSchema>({
    mutationFn: async ({ id, ...payload }) =>
      apiClient.request({
        method: 'PATCH',
        endpoint: `/api/v1/addresses/${id}`,
        payload,
      }),
  });

export const useValidateAddressMutation = () =>
  useMutation<AddressValidationResponse, ApiError, AddressValidationRequest>({
    mutationFn: async (payload) =>
      apiClient.request({
        method: 'POST',
        endpoint: '/api/v1/validate-address',
        payload,
      }),
  });
